<template>
  <div>
    <div class="items" v-if="isPaymentDetailsEntered">
      <div class="items-head">
        <p>STRIPE LIVE API {{ $tc('key', 3) }}</p>
        <!-- <div
			class="add-btn"
			@click="
				isEditing = !isEditing
				isActive = !isActive
				secretKeyToDisplay = isEditing === true ? '' : maskedKey
			"
			>
			<font-awesome-icon class="icon" icon="edit" />
			{{ $t('changeDetails') }}
			</div>
			<hr /> -->
      </div>
      <div class="items-body">
        <div class="items-body-content">
          <span class="apiKeys">{{ $t('publishKey') }}: </span>
          <input
            class="inactive"
            v-model="publishableKey"
            :disabled="!isEditing"
            @blur="$v.publishableKey.$touch()"
            v-on:input="errors = null"
            :class="{ active: !isActive, view: !isEditing }"
          />
          <template v-if="$v.publishableKey.$error">
            <div v-if="!$v.publishableKey.required" class="errorMessage">
              {{ $t('publishKeyReq') }}
            </div>
          </template>
        </div>
        <div class="items-body-content">
          <span class="apiKeys">{{ $t('secretKey') }}: </span>
          <input
            class="inactive"
            v-model="secretKeyToDisplay"
            :disabled="!isEditing"
            @blur="$v.secretKeyToDisplay.$touch()"
            :class="{ active: !isActive, view: !isEditing }"
          />
          <template v-if="$v.secretKeyToDisplay.$error">
            <div v-if="!$v.secretKeyToDisplay.required" class="errorMessage">
              {{ $t('secretKeyReq') }}
            </div>
          </template>
          <!-- <button class="eyeIcon" type="password" @click="switchVisibility">
					<span class="input-group-text" @click="showPassword = !showPassword">
						<i class="fa" :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']" aria-hidden="true"></i>
					</span>
					</button>   -->
        </div>
        <hr />
        <div>
          <button
            :disabled="$v.$invalid"
            class="save-btn"
            v-if="isEditing"
            @click="changePaymentDetails"
          >
            <span class="save-txt">{{ $t('save') }}</span>
          </button>
        </div>
      </div>
      <div v-if="this.errors" class="errorMessage">
        {{ this.errors }}
      </div>
    </div>
    <div class="items" v-if="isShippingDetailsEntered">
      <div class="items-head">
        <p v-if="shippingDetails.platform === 'shippypro'">
          SHIPPYPRO LIVE API {{ $tc('key', 0) }}
        </p>
        <p v-if="shippingDetails.platform === 'eurosender'">
          EUROSENDER LIVE API {{ $tc('key', 0) }}
        </p>
        <div
          class="add-btn"
          @click="
            isShippingEditing = !isShippingEditing
            isShippingActive = !isShippingActive
          "
        >
          <font-awesome-icon class="icon" icon="edit" />
          {{ $t('changeKey') }}
        </div>
        <hr />
      </div>
      <div class="items-body">
        <div class="items-body-content">
          <span class="apiKeys">{{ $t('apikey') }}: </span>
          <input
            class="inactive"
            v-model="shippingDetails.key"
            type="text"
            :disabled="!isShippingEditing"
            v-on:input="errorsShipping = null"
            :class="{ active: !isShippingActive, view: !isShippingEditing }"
          />
        </div>
        <hr />
        <div>
          <button
            class="save-btn"
            v-if="isShippingEditing"
            @click="changeShipppingKeyDetails"
          >
            <span class="save-txt">{{ $t('save') }}</span>
          </button>
        </div>
      </div>
      <div v-if="this.errorsShipping" class="errorMessage">
        {{ this.errorsShipping }}
      </div>
    </div>
    <div v-if="isProductShow" class="product-list-bn-block">
      <button class="product-list-btn" @click="redirectToProductListPage()">
        * {{ $tc('GoToProductList') }}
      </button>
      <p class="stripeVerif">* {{ $t('stripeVerification') }}</p>
    </div>
  </div>
</template>

<script>
import ShippingService from '@/services/ShippingService'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {},
  data() {
    return {
      isEditing: false,
      isProductShow: true,
      isActive: false,
      isShippingEditing: false,
      isShippingActive: false,
      errors: null,
      errorsShipping: null,
      passwordFieldType: 'password',
      showPassword: false,
      originalSecretKey: null,
      secretKeyToDisplay: null,
      maskedKey: null,
      publishableKey: null
    }
  },
  validations: {
    publishableKey: { required },
    secretKeyToDisplay: { required }
  },
  methods: {
    changePaymentDetails() {
      if (
        confirm('are you sure? This will rewrite excisting payment details')
      ) {
        this.originalSecretKey = this.secretKeyToDisplay
        this.maskSecretKey()
        this.$store
          .dispatch('addKeys', {
            publishable_key: this.publishableKey,
            secret_key: this.originalSecretKey
          })
          .then(response => {
            if (
              response.data.flagKeyExists &&
              response.data.flagKeyExists === true
            ) {
              this.errors = this.$t('keyAlreadyExist')
            } else {
              this.isEditing = !this.isEditing
              this.isActive = !this.isActive
            }
          })
          .catch(err => {
            this.errors = err.response.data.response
          })
      }
    },
    changeShipppingKeyDetails() {
      if (
        confirm('are you sure? This will rewrite existing shipping details')
      ) {
        ShippingService.postShippingKey({
          key: this.shippingDetails.key,
          platform: this.shippingDetails.platform
        })
          .then(() => {
            this.isShippingEditing = !this.isShippingEditing
            this.isShippingActive = !this.isShippingActive
          })
          .catch(err => {
            this.errorsShipping = err.response.data.response
          })
      }
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    maskSecretKey() {
      const matchedArray = this.originalSecretKey.match(
        /[a-z]+_[a-z]+_[a-zA-z0-9]{3}(.*)[a-zA-z0-9]{6}/
      )
      if (matchedArray.length > 0) {
        this.maskedKey = this.originalSecretKey.replace(
          matchedArray[1],
          '*'.repeat(matchedArray[1].length)
        )
        this.secretKeyToDisplay = this.maskedKey
      }
    },
    selectType(value) {
      this.isProductShow = value
    },
    redirectToProductListPage() {
      const user = localStorage.getItem('user')
      let routeData = this.$router.resolve({
        name: 'productList',
        params: { clientId: JSON.parse(user).id }
      })
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.publishableKey = this.paymentDetails.publishable_key
    this.originalSecretKey = this.paymentDetails.secret_key
    this.maskSecretKey()
  },
  props: {
    paymentDetails: {
      type: Object,
      required: true
    },
    shippingDetails: {
      type: Object,
      required: true
    },
    isPaymentDetailsEntered: {
      type: Boolean,
      default: false
    },
    isShippingDetailsEntered: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
$sec: #fff;
$primary: #b97b42;
$dark-pri: rgb(44, 62, 80);
* {
  box-sizing: border-radius;
}

.active {
  border-radius: 3.5px;
  background: none !important;
  font-weight: 600;
  font-style: normal !important;
}
.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  // font-style: italic;
}

.eyeIcon {
  position: relative;
}
.input-group-text {
  width: 45px;
}

.add-btn {
  background: var(--primaryDark);
  border-radius: 5px;
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  max-width: 150px;
  width: 100%;
  margin-bottom: 20px;
  margin-left: 20px;
}

.save-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.3em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 5px;
  width: 120px;
  height: 30px;
}

.product-list-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  align-self: center;
  border-radius: 5px;
  width: 250px;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.items {
  width: 100%;
  margin: auto;
  max-width: 750px;
  background: $sec;
  box-shadow: 0 3px 6px rgba(black, 0.16), 0 3px 6px rgba(black, 0.23);
  border-top: 10px solid var(--primaryDark);
}

.save-txt {
  // margin-left: 5px;
  padding: 7px;
}

.items-head p {
  padding: 5px 20px;
  margin: 10px;
  color: $dark-pri;
  font-weight: bold;
  font-size: 20px;
}

.items-head hr {
  width: 20%;
  margin: 0px 30px;
  border: 1px solid $dark-pri;
}
.apiKeys {
  text-align: left;
  font-size: 1.1vw;
}
.items-body {
  padding: 10px;
  margin: 10px;
  display: grid;
  grid-gap: 10px;
}

.items-body-content {
  padding: 10px;
  display: grid;
  grid-template-columns: 10fr 1fr;
  // background-color: lightblue;
  font-size: 13px;
  grid-gap: 10px;
  border: 1px solid transparent;
  cursor: pointer;
}

.items-body-content:hover {
  border-radius: 15px;
  border: 1px solid $dark-pri;
}

.items-body-content i {
  align-self: center;
  font-size: 15px;
  color: $dark-pri;
  font-weight: bold;
  animation: icon 1.5s infinite forwards;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 1em;
}

@keyframes icon {
  0%,
  100% {
    transform: translate(0px);
  }
  50% {
    transform: translate(3px);
  }
}
@media screen and (min-width: 900px) {
  .items-body-content {
    grid-template-columns: 10fr;
  }
  .product-list-bn-block {
    text-align: center;
    margin-top: 50px;
  }
  .stripeVerif {
    font-size: 0.6em;
    margin-top: 10px;
  }
}
@media screen and (max-width: 900px) {
  .apiKeys {
    font-size: 1.55vw;
  }
  .product-list-bn-block {
    text-align: center;
    margin-top: 30px;
  }
}
@media screen and (max-width: 600px) {
  .apiKeys {
    font-size: 1.75vw;
  }
  .items-body-content {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 400px) {
  .add-btn {
    font-size: 0.6em;
  }
  .apiKeys {
    font-size: 3vw;
  }
  .stripeVerif {
    font-size: 0.8em;
    margin-top: 10px;
    text-align: justify;
  }
}
</style>
